import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: '100%',
    },
    overlay: {
      opacity: 0.5,
    },
    topRow: {
      display: 'flex',
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(3),
    },
    bottomRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(3),
    },
    textField: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
    textFieldMultiline: {
      width: '100%',
    },
    maxTextLength: {
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(1),
    },
    progress: {
      marginTop: theme.spacing(3),
    },
    inputProps: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
      height: theme.spacing(17),
    },
    dialogActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(6),
    },
    deleteButton: {
      marginLeft: -theme.spacing(1),
    },
    editActions: {
      justifyContent: 'space-between',
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    switchesContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(2),
    },
    sectionTitle: {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(2),
    },
    addOptionIcon: {
      marginLeft: theme.spacing(0),
      color: theme.palette.primary.main,
      fontSize: theme.spacing(2),
    },
    addOptionContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      alignContent: 'center',
      width: theme.spacing(15),
      cursor: 'pointer',
    },
    addOptionButton: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    inlineFields: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(3),
    },
    switch: {
      width: '65%',
      marginBottom: theme.spacing(1),
    },
    orderSelect: {
      width: '45%',
    },
    subTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      marginBottom: theme.spacing(1),
    },
    textFieldContainer: {
      flexDirection: 'column',
      marginRight: 5,
    },
  }),
);

export default useStyles;
